// Authority Gap — Product catalog (single source of truth for pricing & copy)

export const PRODUCTS = {
  score: {
    slug: "score",
    name: "Free Build-Ready Score",
    price: 0,
    priceLabel: "Free",
    tagline: "The starting point. Find out what you could build.",
    route: "/score",
    delivers: [
      "Build-Ready Score (0–100)",
      "Seven-dimension breakdown",
      "Biggest opportunity identified",
      "Where to start this month",
    ],
    ctaLabel: "Take the Assessment",
  },
  audit: {
    slug: "audit",
    name: "Build-Ready Audit",
    price: 49,
    priceLabel: "$49",
    tagline: "The deeper read. See exactly how to package what you already know.",
    route: "/audit",
    delivers: [
      "Full scored assessment across 7 dimensions",
      "10-minute Loom video walkthrough",
      "Top 3 opportunities to package, in priority order",
      "Top 3 build-moves for the next 30 days, with effort/impact",
      "Delivered within 48 hours",
    ],
    ctaLabel: "See how to package this — $49",
    stripeProduct: "audit",
  },
  blueprint: {
    slug: "blueprint",
    name: "Authority Blueprint",
    price: 497,
    priceLabel: "$497",
    tagline: "The full plan. Build the business hiding in what you already know.",
    route: "/blueprint",
    delivers: [
      "Positioning statement",
      "Full opportunity analysis — what to package first",
      "Ecosystem map — which assets to build, in what order",
      "Content strategy and lead-magnet plan",
      "Tool opportunities",
      "Product ladder",
      "Monetization plan",
      "90-day roadmap",
      "Delivered within 3–5 business days",
    ],
    ctaLabel: "Build the full playbook — $497",
    stripeProduct: "blueprint",
  },
  launch_kit: {
    slug: "launch-kit",
    name: "AuthorityOS Launch Kit",
    price: 2500,
    priceLabel: "$2,500",
    tagline: "The foundation. Assets built for you.",
    route: "/launch-kit",
    delivers: [
      "Brand identity",
      "Website (5 core pages)",
      "Lead magnet created",
      "Email sequence (5 emails)",
      "25 SEO article outlines",
      "AI assistant built",
      "Analytics configured",
      "Clean handoff — no monthly retainer",
      "Delivered within 2 weeks",
    ],
    ctaLabel: "Start the Launch Kit — $2,500",
    stripeProduct: "launch_kit",
  },
  build: {
    slug: "build",
    name: "AuthorityOS Build",
    price: 7500,
    priceLabel: "$7,500",
    tagline: "Done For You. Everything except the Content Engine.",
    route: "/build",
    delivers: [
      "Complete authority ecosystem designed and built",
      "Custom tools and AI assistant deployed",
      "Lead magnets, email sequence, offer ladder",
      "Monetization activated",
      "Automation workflows",
      "Authority AI Brain access (private implementation guide)",
      "30–90 day support",
      "Full training and handoff",
    ],
    ctaLabel: "Start the Build — $7,500",
    stripeProduct: "build",
  },
  build_content_engine: {
    slug: "build-plus-content-engine",
    name: "AuthorityOS Build + Content Engine",
    price: 10000,
    priceLabel: "$10,000",
    tagline: "Flagship. Done For You — including the full Content Engine.",
    route: "/build-plus-content-engine",
    delivers: [
      "Everything in AuthorityOS Build",
      "Content Engine fully deployed",
      "SEO article generation pipeline",
      "Claude Code workflows configured",
      "Remotion video pipeline",
      "AI Avatar integration",
      "Blotato publishing automation",
      "Distribution system across owned + rented channels",
      "Authority AI Brain access (private implementation guide)",
    ],
    ctaLabel: "Start the Flagship Build — $10,000",
    stripeProduct: "build_content_engine",
  },
  enterprise: {
    slug: "enterprise",
    name: "Enterprise",
    price: null,
    priceLabel: "Custom",
    tagline: "Multi-expert organizations. Centralized administration.",
    route: "/work",
    delivers: [
      "One admin account, multiple member-expert accounts",
      "Each expert gets their own Score, Audit, Blueprint, and Build",
      "Centralized org-level admin dashboard",
      "Cross-member analytics (admin only)",
      "Custom onboarding for medical practices, law firms, brokerages, agencies, and similar organizations",
    ],
    ctaLabel: "Let's talk",
  },
};

export const PRODUCT_LIST = Object.values(PRODUCTS);
